import type { IOrganizationOwnershipReceivedNotificationData } from "@frontend-shared/types";
import { Crown } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IOrganizationOwnershipReceivedCardProps {
  uuid: string;
  data: IOrganizationOwnershipReceivedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewOrganization: (organizationUuid: string) => void;
}

const OrganizationOwnershipReceivedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewOrganization,
}: IOrganizationOwnershipReceivedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewOrganization = useCallback(
    () => onViewOrganization(data.organizationUuid),
    [onViewOrganization, data.organizationUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="organization_ownership_received"
      createdAt={createdAt}
      isRead={isRead}
      icon={<Crown className="h-5 w-5" />}
      ctaLabel={t("view_organization")}
      onCtaClick={handleViewOrganization}
      body={t(
        data.isOwnershipTransferred
          ? "type.organization_ownership_received.transferred_body"
          : "type.organization_ownership_received.body",
        {
          organizationName: data.organizationName,
          previousOwnerName: data.previousOwnerName,
        },
      )}
    />
  );
};

export const OrganizationOwnershipReceivedCard = memo(
  OrganizationOwnershipReceivedCardComponent,
);
